import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

type Props = {
	shortStayParams: ForAutoGenerator<
		| {
				maximumStayDates?: number | undefined;
		  }
		| null
		| undefined,
		""
	>;
	onSetShortStayParams: (input: number | undefined) => void;
};
export const QuestionPlanShortStayParams = ({ shortStayParams, onSetShortStayParams }: Props) => {
	const label = "最長連泊期間";
	const guide = "このプランの連泊数に制限をかけることができます。<br />ここでは最長宿泊日数を設定できます。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label}
			guide={guide}
			isEdited={shortStayParams?.maximumStayDates?.isEdited}
			hasError={Boolean(shortStayParams?.maximumStayDates?.error)}
			inputChildren={
				<QuestionSectionWrapper>
					<InputNumberField
						value={shortStayParams?.maximumStayDates?.value}
						handleInput={onSetShortStayParams}
						errorMessage={shortStayParams?.maximumStayDates?.error}
						hiddenSpinButton={false}
					/>
					<p>
						泊 <strong className="underline decoration-2 underline-offset-2">まで</strong> 宿泊可能
					</p>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionPlanShortStayParams.displayName = "QuestionPlanShortStayParams";
